import { FC, useState } from 'react';
import { Translate } from 'react-localize-redux';

import useTranslate from '../../hooks/useTranslate';
import { TeeTimeType } from '../../services/apis/teeTimes/types';
import { isEligibleForHighlight } from '../../services/apis/teeTimes/utils';
import Button from '../Button/Button';
import TeeTime from './TeeTime';

const DEFAULT_VISIBLE_ITEMS = 14;

type TeeTimesProps = {
  items: TeeTimeType[];
  currency: string;
  onSelect: (value: TeeTimeType) => void;
  onShowMap?: () => void;
  selectedNumberOfPlayers?: number;
  shouldHighlight?: boolean;
  mapVisible?: boolean;
};

const TeeTimes: FC<TeeTimesProps> = props => {
  const {
    items: allItems,
    onSelect,
    currency,
    selectedNumberOfPlayers,
    shouldHighlight,
    onShowMap,
    mapVisible,
  } = props;
  const { translate } = useTranslate();
  const [showAll, setShowAll] = useState(false);
  const items = showAll ? allItems : allItems?.slice(0, DEFAULT_VISIBLE_ITEMS);

  return (
    <>
      <div className="d-flex flex-wrap gap-3">
        {items?.map(item => {
          const highlighted = shouldHighlight && isEligibleForHighlight(item);

          return (
            <TeeTime
              key={item.dateTime}
              teeTime={item}
              currency={currency}
              onClick={() => onSelect(item)}
              selectedNumberOfPlayers={selectedNumberOfPlayers}
              highlighted={highlighted}
              tooltip={highlighted ? translate('teeTimeSellOutTooltip') : null}
            />
          );
        })}
        {items?.length > 0 && !showAll && (
          <Button
            outline
            tertiary
            onClick={() => setShowAll(true)}
            className="small"
            style={{ width: '77px' }}
          >
            <Translate id="default.showMoreAmount" />
          </Button>
        )}
      </div>

      <div className="text-end">
        {onShowMap && !mapVisible && (
          <Button
            primary
            onClick={onShowMap}
            className="mt-3 mr-1"
            style={{ marginRight: '0.25rem' }}
          >
            <Translate id="District.ShowMap" />
          </Button>
        )}
      </div>
    </>
  );
};

export default TeeTimes;
